// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"252c97f0","669":"01ca5b93","865":"654d7d73"}[chunkId] + ".chunk.js";
};